import Skeleton from 'components/common/Skeleton/Skeleton';
import styles from './Pagination.module.scss';

export const PaginationSkeleton = () => {
    return <Skeleton containerClassName={styles.pagination} count={3} className={styles.item} />;
};
